export const CANVAS_REQUEST = "CANVAS_REQUEST";
export const CANVAS_SUCCESS = "CANVAS_SUCCESS";
export const CANVAS_FAILED = "CANVAS_FAILED";
